var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "popup-block pointer noselect",
    on: {
      "click": _vm.selectRest
    }
  }, [_c('div', {
    staticClass: "vertical-align-divs flex-row"
  }, [_c('div', {
    staticClass: "user-relation"
  }, [_vm.item.value ? _c('div', [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f25_icons8-check.svg",
      "alt": ""
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "text-block"
  }, [_c('div', {
    staticClass: "text--black"
  }, [_vm._v(" " + _vm._s(_vm.item.display_name) + " ")])])])])]), _vm.item.hasOwnProperty('dropdownValue') && _vm.item.value ? _c('div', {
    staticClass: "dropdown-input-custom mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.item.dropdownValue.value,
      expression: "item.dropdownValue.value"
    }],
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.item.dropdownValue.value
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.item.dropdownValue, "value", $event.target.value);
      }
    }
  }), _c('dropdown-select', {
    attrs: {
      "id": _vm.item.dropdownValue.id,
      "init-value": _vm.item.dropdownValue.value ? _vm.item.dropdownValue.value : _vm.item.dropdownValue["default"],
      "options": _vm.item.dropdownValue.choices,
      "normal": "",
      "name": _vm.item.dropdownValue.title
    },
    on: {
      "select": function select($event) {
        _vm.item.dropdownValue.value = $event;
      }
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }